import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';

function getUrl() {
  return 'v1/bank-account/banks/';
}

/**
 * @param {string} url
 */
function callbackFetch(url) {
  return async () => {
    try {
      /** @type {import('./typedefs').Response} */
      const res = await fetcher.get(url);

      return res.data.results;
    } catch (err) {
      const resp = err?.response?.data;
      errorLogger('ERROR_API', resp?.err_message || err.message);
      throw resp;
    }
  };
}

export default function fetch() {
  const url = getUrl();

  return {
    cb: callbackFetch(url),
    key: [url],
  };
}
